var render = function render(){var _vm=this,_c=_vm._self._c;return _c('widget-container',{attrs:{"widget":_vm.widget}},[_c('v-row',{style:(`height: 100%; ${
      _vm.hasTitle ? 'padding-bottom: 3rem;' : 'padding-top: 1rem;'
    }`),attrs:{"no-gutters":""}},[(_vm.opts !== undefined && _vm.opts.series.length > 0)?_c('e-chart',{staticStyle:{"width":"100%","max-width":"100%","min-height":"100%","max-height":"100%"},attrs:{"option":_vm.opts,"autoresize":true}}):_c('h3',{staticStyle:{"height":"100%","text-align":"center"}},[_vm._v("Not enough data")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }